import * as React from 'react';
import TableBody from '@mui/material/TableBody';

export default function UiTableBody(props) {
  return (
    <>

        <TableBody {...props}/>
   </>
  );
}